// Phase-1 comprehension reader — passage join index.
// CQ_* comprehensionQuestions carry a passageId that joins to
// decodablePassages[].id. Build the lookup ONCE (module-load) so the mapper can
// attach the full passage body to each question without a per-item scan.
import decodablePassages from "../data/content/decodablePassages.json";

interface PassageSentence { sentence_id: string; text: string }
interface DecodablePassage { id: string; title?: string; sentences: PassageSentence[] }

const PASSAGE_BY_ID: ReadonlyMap<string, DecodablePassage> = new Map(
  (decodablePassages as unknown as DecodablePassage[]).map((p) => [p.id, p]),
);

/** Resolve a passage by id (=== comprehensionQuestions[].passageId). null when
 *  it doesn't join (e.g. the DP001_CQ* ERN items whose passage isn't bundled). */
export function passageById(id: string | undefined): DecodablePassage | null {
  if (!id) return null;
  return PASSAGE_BY_ID.get(id) ?? null;
}
/** Every valid passage id — for join-integrity tests. */
export function allPassageIds(): ReadonlySet<string> { return new Set(PASSAGE_BY_ID.keys()); }
